import { forwardRef, type TextareaHTMLAttributes } from 'react';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  hint?: string;
}

/* Forwards its ref to the <textarea>: a box that sizes itself to its content
   (the outline editor) has to measure the element. */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea({ label, hint, required, rows = 4, className = '', ...rest }, ref) {
  const control = (
    <div className="tr-field__control tr-textarea-wrap">
      <textarea ref={ref} className="tr-textarea" rows={rows} required={required} {...rest} />
    </div>
  );
  if (!label) return control;
  return (
    <label className={`tr-field ${className}`.trim()}>
      <span className="tr-field__label">
        {label}
        {required && <span className="tr-field__req">*</span>}
      </span>
      {control}
      {hint && <span className="tr-field__hint">{hint}</span>}
    </label>
  );
});
